import * as React from "react";
import { Box, Card, CardContent, Typography, Alert, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { BarChart, ChartsTooltip, ChartsAxis, BarElement } from "@mui/x-charts";

export const SafeBarChart = ({
  data,
  title,
  xKey = "month",
  yKey = "count",
  height = 300,
}) => {
  const theme = useTheme();

  if (!data || data.length === 0) {
    return (
      <Card
        sx={{
          background: alpha(theme.palette.background.paper, 0.8),
          backdropFilter: "blur(8px)",
        }}
      >
        <CardContent>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            {title}
          </Typography>
          <Alert severity="info">No data available for this chart</Alert>
        </CardContent>
      </Card>
    );
  }

  const chartData = data.map((item) => ({
    [xKey]: `${item.month || item.type} ${item.year || ""}`.trim(),
    [yKey]: parseInt(item[yKey] || 0),
  }));

  return (
    <Card
      sx={{
        background: alpha(theme.palette.background.paper, 0.8),
        backdropFilter: "blur(8px)",
        height: "100%",
      }}
    >
      <CardContent>
        <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ mb: 2 }}>
          {title}
        </Typography>
        <Box sx={{ height }}>
          <BarChart
            dataset={chartData}
            xAxis={[
              {
                scaleType: "band",
                dataKey: xKey,
                label: xKey === "month" ? "Month" : "Type",
                labelStyle: { fontSize: 12, fill: theme.palette.text.primary },
                tickLabelStyle: { fontSize: 10, fill: theme.palette.text.secondary },
              },
            ]}
            series={[
              {
                dataKey: yKey,
                label: yKey === "count" ? "Count" : "Revenue",
                color: theme.palette.primary.main,
                highlightScope: { highlighted: "item", faded: "global" },
              },
            ]}
            yAxis={[
              {
                label: yKey === "count" ? "Number of Orders" : "Revenue (SDG)",
                labelStyle: { fontSize: 12, fill: theme.palette.text.primary },
              },
            ]}
            colors={[theme.palette.primary.main]}
            grid={{ vertical: true }}
          >
            <ChartsAxis />
            <ChartsTooltip
              formatter={(value) =>
                yKey === "count" ? value : formatSDG(value)
              }
            />
            <BarElement style={{ rx: 4, ry: 4 }} />
          </BarChart>
        </Box>
      </CardContent>
    </Card>
  );
};

// Helper (can be moved to a separate utils file)
const formatSDG = (amount) => {
  if (!amount) return "0 SDG";
  amount = Number(amount);
  if (isNaN(amount)) return "0 SDG";
  if (amount >= 1000000) return `${(amount / 1000000).toFixed(1)}M SDG`;
  if (amount >= 1000) return `${(amount / 1000).toFixed(1)}K SDG`;
  return `${amount.toLocaleString()} SDG`;
};